import { Box3, Vector3, Mesh } from "three";
export function getSurfaceMapping(productMapping, fullBleed) {
  const keys = Object.keys(productMapping);
  const surfaceMapping = {};
  keys.forEach(key => {
    const prodSurface = {
      substrate: productMapping[key].substrate,
      finishes: productMapping[key].finishes,
      page: productMapping[key].page,
      fullBleed: productMapping[key].fullBleed || fullBleed,
      trim: productMapping[key].trim,
      focalPoint: productMapping[key].focalPoint
    };
    surfaceMapping[key] = prodSurface;
  });
  return surfaceMapping;
}
export function centerModel(positionOffset, meshGroup) {
  // Find the center of the geometry
  const bounds = new Box3().setFromObject(meshGroup);
  const center = bounds.getCenter(new Vector3());
  // Apply position offsets if they exist
  if (positionOffset) {
    center.x -= positionOffset.x;
    center.y -= positionOffset.y;
    center.z -= positionOffset.z;
  }
  // Translate the center of the model to the origin
  meshGroup.position.set(-center.x, -center.y, -center.z);
  meshGroup.updateMatrix();
  return meshGroup;
}
export function findMeshRecursively(group, onFound) {
  if (!group.children || group.children.length === 0) return;
  group.children.forEach(child => {
    // Only load the types of elements that will render something. More info https://threejs.org/docs/#api/en/objects/Mesh
    child instanceof Mesh && onFound(child);
    findMeshRecursively(child, onFound);
  });
}